<gp-documents-list
  *ngIf="essService.employee"
  [selectedContract]="selectedContract?.id"
  [employee]="essService.employee"
  [availability]="TemplateAvailability.EMPLOYEE"
  [cliRegId]="selectedContract?.cliRegID">
</gp-documents-list>
